import { render, staticRenderFns } from "./InquiryAdjustment.vue?vue&type=template&id=571ddecc&"
import script from "./InquiryAdjustment.vue?vue&type=script&lang=ts&"
export * from "./InquiryAdjustment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('571ddecc')) {
      api.createRecord('571ddecc', component.options)
    } else {
      api.reload('571ddecc', component.options)
    }
    module.hot.accept("./InquiryAdjustment.vue?vue&type=template&id=571ddecc&", function () {
      api.rerender('571ddecc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/assets/Inquiry/InquiryAdjustment.vue"
export default component.exports